<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">
    <h1 class="questions__header">{{ $t("Systemname") }}</h1>

    <p>{{
        $t('The system name is used by all your employees and administrators across all sites and departments. Choose an easily recognizable name, preferably your company name. Enter your system name below, without spaces, capital letters or special characters, for example: {systemName}.', {systemName: systemNameExample})
      }}</p>
    <h2 class="questions__subheader">{{ $t("Desired system name") }}</h2>
    <div class="inputinline">
      <p id="questions__systemname">app.planning.nu/</p>
      <input
        id="questions__systemnameInput"
        v-model="systemSettings.systemUrl"
        :class="{wrongIban: systemnameExisting}"
        class="form-control text-lowercase"
        pattern=".{3,}"
        type="text"
        @change="systemNameExisting"
      /><br>
      <p class="questions__inputerrordescription questions--noinputmargin">{{ inputErrorDescription }}</p>
    </div>

    <h2 class="questions__subheader">{{ $t("Default system language") }}</h2>
    <b-form-select
      id="questions-dropdownHalf"
      v-model="systemSettings.systemLanguage"
      class="mb-3">
      <option value="NL">
        {{ $t("Dutch") }}
      </option>
      <option value="EN">
        {{ $t("English") }}
      </option>
      <option value="DE">
        {{ $t("German") }}
      </option>
      <option value="FR">
        {{ $t("French") }}
      </option>
      <option value="ES">
        {{ $t("Spanish") }}
      </option>
    </b-form-select>

    <h2 class="questions__subheader">{{ $t("Remarks") }}</h2>
    <b-form-textarea
      v-model="systemSettings.systemSettingsRemarks"
      class="questions__textarea"
      rows="3"/>

    <input :value="$t('Save')" type="button" @click="handleSave"/>
    <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "@/GlobalFunctions";

export default {
  name: 'Systemname',
  data() {
    return {
      selected: '',
      systemNameExample: null,
      systemnameExisting: false,
      inputErrorDescription: null,
      showSaveStatus: false,
      safeFreeze: false,
      displayFrontend: false,
      systemSettings: {
        systemUrl: null,
        systemLanguage: null,
        systemSettingsRemarks: null,
      }
    };
  },
  async beforeMount() {
    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return;
    }

    this.systemSettings.systemUrl = result.systemUrl;
    this.systemSettings.systemLanguage = result.systemLanguage;
    this.systemSettings.systemSettingsRemarks = result.systemSettingsRemarks;
    this.systemNameExample = this.accountNameToSystemName(result.accountName);

    if (this.systemSettings.systemLanguage === null) {
      this.systemSettings.systemLanguage = result.accountLanguage;
    }

    GlobalFunctions.setReadOnly(result.isSigned);
    localStorage.setItem('startingObject', JSON.stringify(this.systemSettings));
    this.displayFrontend = true;
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.systemSettings, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    async systemNameExisting() {
      this.inputErrorDescription = null;

      const result = await SystemRequestService.systemNameExisting(this.systemSettings.systemUrl);
      this.systemnameExisting = result.systemNameExisting;

      if (result.systemNameExisting) {
        this.inputErrorDescription = this.$t("This system name is not available");
      }
    },
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;
      const result = await SystemRequestService.updateProject(this.systemSettings, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.systemSettings));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
      }, 3000);
    },
    accountNameToSystemName(accName) {
      let accountName = accName.toLowerCase();
      const toRemove = ['b.v.', 'v.o.f.', 'gmbh', 'n.v.', 'stichting', 'c.v.', 'ltd.', 'bvba'];
      toRemove.forEach(entry => {
        accountName = accountName.replace(entry, '');
      });
      return accountName.replace(/[^a-zA-Z]/g, "");
    }
  },
};
</script>
